<template>
    <div>
        <h2>this is the heading of the Test component</h2>
    </div>
</template>

<script>
    export default{
        mounted(){
            alert('test');
        }
    }
</script>
